import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

export const useModal = () => {
  const [open, setOpen] = useState(false);
  return {
    open,
    setOpen,
  };
};

const Modal = ({ titre, className, open, onClose, children }) => {
  const dialogRef = useRef();

  const closeModal = () => {
    dialogRef.current.close();
  };

  const onBackdropClicked = (event) => {
    if (event.target === dialogRef.current) {
      closeModal();
    }
  };

  useEffect(() => {
    if (open) {
      dialogRef.current.showModal();
    } else {
      closeModal();
    }
  }, [open]);

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    dialogRef.current.addEventListener('close', () => {
      // On passe par l'événement au lieu de juste ajouter l'appel à onClose() dans la fonction closeModal
      // car la fonction closeModal n'est pas appelée si l'utilisateur presse la touche ESC
      // ce qui aura pour effet de fermer la modale
      onClose();
    });
  }, [dialogRef]);
  /* eslint-enable react-hooks/exhaustive-deps */

  return (
    <dialog
      className={`modal ${className}`}
      onClick={onBackdropClicked}
      ref={dialogRef}
    >
      <div className="modal-titre">
        {titre}
        <span className="modal-titre-close" onClick={closeModal}>
          &times;
        </span>
      </div>
      <div className="modal-content">
        <div className="modal-body">{children}</div>
      </div>
    </dialog>
  );
};
Modal.propTypes = {
  titre: PropTypes.string,
  className: PropTypes.string,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default Modal;
